import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import ImportTrip from '../../components/import/Import'

export function mapStateToProps(state: IStoreState) {
  return {
    currentOrgId: state.organizations.currentOrgId
  }
}

export default connect(mapStateToProps)(ImportTrip)



// WEBPACK FOOTER //
// ./src/containers/import/Import.ts